import React from "react";
import '../css/winnerSerials.scss'

const serialsMoney = [ "0031820", "0014794" ]
const serialsMoto = [ "0014416", "0011873", "0023555" ]
const mountAwards = ["56", "620"]

const WinnerSerials = (renderList) => {

  const moneyList = serialsMoney.map((item) => 
    <span>{item}</span>
  );

  const motoList = serialsMoto.map((item) => 
    <span>{item}</span>
  );

  return (
    <div className="winners">
      <div className="prospects-7">
        {/* <span className="hits">Ganadores con 7 aciertos: </span> */}
        <span className="mount">{'Hay Ganadores'}</span>
      </div>
      {/* <div className="prospects-8">
        <span className="hits">Ganadores con 8 aciertos: </span>
        <span className="mount">No hubo ganador</span>
      </div>
      <div className="prospects-9">
        <span className="hits">Ganadores con 9 aciertos: </span>
        <span className="mount">No hubo ganador</span>
      </div> */}
      <div className="serials">
        <div className="mount">
          <h3>No hubo sorteo de serial</h3>
          
        </div>
        {/* <div className="moto">
          <h3>Seriales Motos</h3>
          {motoList}
        </div> */}
      </div>
    </div>
  )
}

export default WinnerSerials;